import { render } from "./UserDesktopNav.vue?vue&type=template&id=576463a4"
import script from "./UserDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script